import api from './api';

export const profileService = {
  // Obter perfil do usuário logado
  getMyProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  // Obter perfil de outro usuário
  getUserProfile: async (userId) => {
    const response = await api.get(`/usuarios/${userId}`);
    return response.data;
  },

  // Obter foto de perfil
  getProfilePhoto: async () => {
    const response = await api.get('/usuarios/profile/photo');
    return response.data;
  },

  // Alterar senha
  changePassword: async (passwordData) => {
    const response = await api.post('/usuarios/change-password', passwordData);
    return response.data;
  },

  // Upload de foto de perfil (implementar)
  uploadProfilePhoto: async (formData) => {
    const response = await api.post('/usuarios/profile/photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
  ,

  // Upload de foto de capa
  uploadCoverPhoto: async (formData) => {
    const response = await api.post('/usuarios/profile/cover', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Remover foto de capa
  removeCoverPhoto: async () => {
    const response = await api.delete('/usuarios/profile/cover');
    return response.data;
  },

  // Remover foto de perfil
  removeProfilePhoto: async () => {
    const response = await api.delete('/usuarios/profile/photo');
    return response.data;
  }
};
